"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _constants = require("./constants");
/* eslint-disable no-prototype-builtins */

var FALLBACK_LANG = _constants.ENGLISH_LOCALE;
var showKeys = function showKeys() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }
  return document.location.href.indexOf('showi18n') > 0;
};

// Some characters like $ have special meanings in the replace context.
// Using a function that returns the replace value skips this behaviour.
// https://mattsnider.com/safari-regex-issue-with-0-9-in-replacement-text/
var replaceInterpolatedKey = function replaceInterpolatedKey(key, replacement, target) {
  return target.replace(new RegExp("\\${".concat(key, "}"), 'g'), function () {
    return replacement;
  });
};
var replaceVariables = function replaceVariables(variables, string) {
  Object.keys(variables).forEach(function (key) {
    string = replaceInterpolatedKey(key, variables[key], string);
  });
  return string;
};
var getLocalizedValue = function getLocalizedValue(translations, lang, key) {
  // First try to get the string in the selected language
  if (translations[lang] && translations[lang].hasOwnProperty(key) && translations[lang][key]) {
    return translations[lang][key];
  }

  // Fallback to the key itself if it's not available in English
  if (translations[FALLBACK_LANG] && translations[FALLBACK_LANG].hasOwnProperty(key)) {
    return translations[FALLBACK_LANG][key];
  }
  return key;
};
var createTranslator = function createTranslator() {
  var translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var lang = arguments.length > 1 ? arguments[1] : undefined;
  var warn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.warn;
  return function () {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!lang || showKeys()) {
      return key;
    }
    var value = getLocalizedValue(translations, lang, key);
    if (value === key && process.env.NODE_ENV === _constants.DEVELOPMENT) {
      warn("Key \"".concat(key, "\" was not found in translation files."));
    }
    return replaceVariables(variables, value);
  };
};
var _default = (0, _memoizeOne["default"])(createTranslator);
exports["default"] = _default;